"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefSequenceResult = exports.LocStringResult = exports.default = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BaseResult = /*#__PURE__*/function () {
  function BaseResult(args) {
    (0, _classCallCheck2.default)(this, BaseResult);
    (0, _defineProperty2.default)(this, "label", void 0);
    (0, _defineProperty2.default)(this, "renderingComponent", void 0);
    (0, _defineProperty2.default)(this, "matchedAttribute", void 0);
    (0, _defineProperty2.default)(this, "matchedObject", void 0);
    (0, _defineProperty2.default)(this, "textSearchAdapter", void 0);
    (0, _defineProperty2.default)(this, "relevance", void 0);
    (0, _defineProperty2.default)(this, "trackId", void 0);
    (0, _defineProperty2.default)(this, "score", void 0);
    this.label = args.label;
    this.renderingComponent = args.renderingComponent;
    this.matchedAttribute = args.matchedAttribute;
    this.matchedObject = args.matchedObject;
    this.textSearchAdapter = args.textSearchAdapter;
    this.relevance = args.relevance;
    this.trackId = args.trackId;
    this.score = args.score || 1;
  }

  (0, _createClass2.default)(BaseResult, [{
    key: "getLabel",
    value: function getLabel() {
      return this.label;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.label;
    }
  }, {
    key: "getRenderingComponent",
    value: function getRenderingComponent() {
      return this.renderingComponent;
    }
  }, {
    key: "getTrackId",
    value: function getTrackId() {
      return this.trackId;
    }
  }, {
    key: "getScore",
    value: function getScore() {
      return this.score;
    }
  }, {
    key: "updateScore",
    value: function updateScore(newScore) {
      this.score = newScore;
      return this.score;
    }
  }]);
  return BaseResult;
}();
/**
 * Future types of results
 * e.g: reference sequence results, track results,
 * feature results
 */


exports.default = BaseResult;

var LocStringResult = /*#__PURE__*/function (_BaseResult) {
  (0, _inherits2.default)(LocStringResult, _BaseResult);

  var _super = _createSuper(LocStringResult);

  function LocStringResult(args) {
    var _args$locString;

    var _this;

    (0, _classCallCheck2.default)(this, LocStringResult);
    _this = _super.call(this, args);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "locString", void 0);

    if (!args.locString) {
      throw new Error('must provide locString');
    }

    _this.locString = (_args$locString = args.locString) !== null && _args$locString !== void 0 ? _args$locString : '';
    return _this;
  }

  (0, _createClass2.default)(LocStringResult, [{
    key: "getLocation",
    value: function getLocation() {
      return this.locString;
    }
  }]);
  return LocStringResult;
}(BaseResult);

exports.LocStringResult = LocStringResult;

var RefSequenceResult = /*#__PURE__*/function (_BaseResult2) {
  (0, _inherits2.default)(RefSequenceResult, _BaseResult2);

  var _super2 = _createSuper(RefSequenceResult);

  function RefSequenceResult(args) {
    var _args$refName;

    var _this2;

    (0, _classCallCheck2.default)(this, RefSequenceResult);
    _this2 = _super2.call(this, args);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "refName", void 0);

    if (!args.refName) {
      throw new Error('must provide refName');
    }

    _this2.refName = (_args$refName = args.refName) !== null && _args$refName !== void 0 ? _args$refName : '';
    return _this2;
  }

  (0, _createClass2.default)(RefSequenceResult, [{
    key: "getLocation",
    value: function getLocation() {
      return this.refName;
    }
  }]);
  return RefSequenceResult;
}(BaseResult);

exports.RefSequenceResult = RefSequenceResult;